import React from 'react';

export const FleetPage = () => {
  return (
    <div className="py-10" data-testid="fleet-page">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">Our Fleet</h1>
        <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
          Our modern, well-maintained fleet ensures your cargo arrives safely and on time.
        </p>

        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold mb-4">Fleet Specifications</h2>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start">
                <svg className="w-6 h-6 text-blue-600 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Modern tractors and chassis for 20', 40', and 45' containers</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-blue-600 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Regular maintenance schedules for optimal performance</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-blue-600 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>GPS tracking on all vehicles</span>
              </li>
            </ul>
          </div>
          <div>
            <img src="https://customer-assets.emergentagent.com/job_cargo-pricing/artifacts/cqgq8ydu_GettyImages-1219610363.webp" alt="Fleet" className="rounded-lg shadow-lg" />
          </div>
        </div>

        <div className="mt-12 bg-blue-50 p-8 rounded-lg">
          <h2 className="text-2xl font-bold mb-4">Safety & Compliance</h2>
          <p className="text-gray-600 mb-4">
            All our vehicles meet or exceed DOT safety standards. Our drivers are thoroughly trained and certified, ensuring the highest level of safety and professionalism on every delivery.
          </p>
          <p className="text-gray-600">
            We maintain comprehensive insurance coverage and comply with all federal and state regulations for container drayage operations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FleetPage;